import { HELP_GROUPS, HELP_COMING_SOON } from '../../lib/help';
import './help.css';

/* Full Help surface (card FiLhF6LRwAAP — Jonathan email 2026-10-11): every
   feature in the app, grouped by tab, each with the same three beats the
   tooltips use — what it is, why it helps the two of you, one example.
   The inventory (web/src/lib/help.ts) is the single source, so Help and the
   in-context tips can never disagree. Copy only — no network, no state.

   Rendered inside the .pear-panel App.tsx wraps it in (like reveal-history),
   so this block lays itself out; the panel owns the scrollbar. */

interface HelpProps {
  onClose: () => void;
  /** Hand off to the nine-step tour (card Tw2G4BUmOF5o): Help is the other
   *  place the tour now lives, so it can be opened from either surface. */
  onTour: () => void;
}

export function Help({ onClose, onTour }: HelpProps) {
  return (
    <section className="help" aria-labelledby="help-title" data-testid="help-screen">
      <div className="help-head">
        <h2 className="help-title" id="help-title">
          Help
        </h2>
        <button
          type="button"
          className="help-close"
          id="btn-help-close"
          onClick={onClose}
        >
          Close
        </button>
      </div>

      <p className="help-lede">
        Everything Pear does, in one place — what each thing is, why it is useful to the
        two of you, and one example of it in a real week.
      </p>

      {/* The tour is the other half of Help (card Tw2G4BUmOF5o): this is the
          written inventory, that is the walk-through — one tap to either.
          2026-10-16 email (card ED6amhdI1lFH): Help keeps the original
          nine-step tutorial, named "Explore Pear". */}
      <button type="button" className="help-tour" id="btn-help-tour" onClick={onTour}>
        Explore Pear — the nine-step tour
      </button>

      {HELP_GROUPS.map(group => (
        <section className="help-group" key={group.tab} aria-labelledby={`help-group-${group.tab}`}>
          <h3 className="help-group-title" id={`help-group-${group.tab}`}>
            {group.label}
          </h3>
          <ul className="help-list">
            {group.features.map(f => (
              <li className="help-item" key={f.id} data-help-feature={f.id}>
                <p className="help-name">{f.name}</p>
                <p className="help-what">{f.what}</p>
                <p className="help-benefit">{f.benefit}</p>
                <p className="help-example">
                  <span className="help-example-label">For example</span> {f.example}
                </p>
              </li>
            ))}
          </ul>
        </section>
      ))}

      {/* Coming soon was commented out of the inventory (2026-10-16 email,
          card ED6amhdI1lFH): Help shows what works today. The section stays
          here behind the length check, so uncommenting an entry in help.ts
          brings the whole block back with its "Coming soon" mark. */}
      {HELP_COMING_SOON.length > 0 && (
        <section className="help-group" aria-labelledby="help-group-soon">
          <h3 className="help-group-title" id="help-group-soon">
            Coming soon
          </h3>
          <ul className="help-list">
            {HELP_COMING_SOON.map(f => (
              <li className="help-item help-item-soon" key={f.id} data-help-feature={f.id} data-soon="true">
                <p className="help-name">
                  {f.name} <span className="help-soon-mark">Coming soon</span>
                </p>
                <p className="help-what">{f.what}</p>
                <p className="help-benefit">{f.benefit}</p>
                <p className="help-example">
                  <span className="help-example-label">For example</span> {f.example}
                </p>
              </li>
            ))}
          </ul>
        </section>
      )}
    </section>
  );
}
